import queryString from 'query-string'
import { instance } from '../../../../utils/coreAPI'
import { MATERIAL_API_PATH } from '../../../../constants/globalConstants'
import { GALLERY_SIZE } from './GalleryModule-constants'

export const getGuestMaterials = async (
  page = 1,
  category: string | undefined,
  tags: string,
  searchStr: string,
  filterDate: string | null,
  sortOrder: string | undefined,
  filterAuthor: string | null
) => {
  const tagsArray = tags ? decodeURI(tags).split(' ') : undefined
  tagsArray?.push(tags);
  const searchArray = searchStr ? decodeURI(searchStr).split(' ') : undefined
  const config = {
    params: {
      page: page,
      size: GALLERY_SIZE,
      category: category ? category : undefined,
      interval: filterDate ? filterDate : undefined,
      tags: tagsArray ? tagsArray : undefined,
      search: searchArray ? searchArray : undefined,
      sort: sortOrder ? sortOrder : 'desc.add',
      contributorId: filterAuthor ? filterAuthor : undefined,
    },
    paramsSerializer: (params: any) => {
      return queryString.stringify(params)
    },
  }
  try {
    const response = await instance.get(MATERIAL_API_PATH, config)
    return response.data
  } catch (error: any) {
    return await Promise.reject(error)
  }
}
